import { DataProcessingAgreementLoaderPort } from '../../../application/ports/DataProcessingAgreementLoaderPort';
import { DataProcessingAgreement } from '../../../domain/DataProcessingAgreement';
import { StorageHttp } from '../../../services/StorageHttp';
import { AxiosRequestConfig } from 'axios';
import { fromStorageResponse } from '../../presenters/DataProcessingAgreementPresenter';
import DataProcessingAgreementDto from '../../presenters/DataProcessingAgreementDto';
import { xmlToJs } from '../../XmlConverter';

type StorageResponse = {
  EnumerationResults: {
    Blobs: {
      Blob: Array<DataProcessingAgreementDto>;
    };
  };
};

export class DataProcessingAgreementApiService implements DataProcessingAgreementLoaderPort {
  async loadLatestVersion(): Promise<DataProcessingAgreement | undefined> {
    const response = await this.loadVersions();
    const json: StorageResponse = xmlToJs(response.data) as StorageResponse;

    const dataProcessingAgreements = fromStorageResponse(json['EnumerationResults'].Blobs.Blob)
      .filter((agreement) => agreement.version !== 'unknown')
      .sort((a, b) => {
        return b.version.localeCompare(a.version);
      });

    return dataProcessingAgreements.shift();
  }

  private async loadVersions() {
    const config: AxiosRequestConfig = { headers: { 'x-ms-version': '2009-09-19' } };

    return StorageHttp.get<string>(
      '/avvversions?restype=container&comp=list&include=metadata&prefix=AVV_TES_E',
      config
    );
  }
}
